import React from 'react';
import { Link, Text } from 'basis';
import { OverviewSources, PRODUCT_CODE_DAVID_JONES_PREMIERE, PRODUCT_CODE_DAVID_JONES_PRESTIGE } from '_config';
import { isFeatureOn } from 'featureToggles';

const earnRateDisclaimerText = {
  [PRODUCT_CODE_DAVID_JONES_PRESTIGE]: 'earn rates and categories',
  [PRODUCT_CODE_DAVID_JONES_PREMIERE]: 'earn rate categories',
};
export function EarnRateDisclaimerContent({ productCode }) {
  if (!isFeatureOn('cvp')) return null;

  const phrase = earnRateDisclaimerText[productCode] ?? 'earn rates and categories';
  return (
    <>
      Effective 25 August 2026 these {phrase} will change.
      <Link newTab href={OverviewSources.AU.disclaimerZenDeskLink.url}>
        {OverviewSources.AU.disclaimerZenDeskLink.label}
      </Link>
      .
    </>
  );
}

export function EarnRateDisclaimer({ productCode, textStyle, margin = '4 0 0 0' }) {
  if (!isFeatureOn('cvp')) return null;
  return (
    <Text textStyle={textStyle} margin={margin}>
      <EarnRateDisclaimerContent productCode={productCode} />
    </Text>
  );
}

export function AnnualFeeDisclaimer({ productCode }) {
  if (!isFeatureOn('cvp')) return null;
  const newAnnualFee = {
    [PRODUCT_CODE_DAVID_JONES_PRESTIGE]: '$345',
    [PRODUCT_CODE_DAVID_JONES_PREMIERE]: '$149',
  }[productCode];

  if (!newAnnualFee) return null;

  return (
    <>
      <Text margin="2 0 0 0">Effective 25 August 2026 the </Text>
      <Text>annual fee will be {newAnnualFee}.</Text>
      <Text> Waived for your first year.</Text>
    </>
  );
}

export function InterestFreePeriod() {
  if (!isFeatureOn('cvp')) return null;
  return (
    <>
      <Text>
        <strong>Note:</strong>
        Effective from 25 August 2026
      </Text>
      <Text>the interest free period on general</Text>
      <Text>purchases will change to up to 44 days.</Text>
    </>
  );
}

export function ContractScheduleAnnualFeeDisclaimer({ productCode }) {
  if (!isFeatureOn('cvp')) return null;

  const newAnnualFee = {
    [PRODUCT_CODE_DAVID_JONES_PRESTIGE]: '345.00',
    [PRODUCT_CODE_DAVID_JONES_PREMIERE]: '149.00',
  }[productCode];

  if (!newAnnualFee) return null;

  return (
    <>
      <Text margin="2 0 0 0">
        <strong>Note: </strong> Effective from 25 August
      </Text>
      <Text>2026 this will change to ${newAnnualFee}</Text>
    </>
  );
}
